import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import useFetchData from '../../../hooks/useFetchData';

const ThisMonthExpenses = () => {
    const { items: expense } = useFetchData("https://servers.thakurgaonexpress.com/rupkotha/getthismonthexpenses");
    const TotalExpense = (Array.isArray(expense) ? expense : []).reduce((total, currentValue) => total + (Number(currentValue?.amount) || 0), 0);


    return (
        // <div class="mx-auto w-11/12 bg-coral text-textPrimary rounded-lg overflow-hidden bg-[#D7BDE2] shadow-lg glassmorphism p-5">
       <div class="modern-card p-5">
            <div className='flex justify-between items-center'>
                <div class="flex flex-col justify-center items-center">
                    <div class="text-sm font-semibold mb-2">This Month Expenses</div>
                    <p class="text-xl text-textPrimary">৳ {TotalExpense.toFixed(2)}</p>
                </div>
                <div className="dashboard-stat-card__icon"><FiArrowUpRight /></div>
            </div>
        </div>
    );
};

export default ThisMonthExpenses;
